module.exports = __webpack_public_path__ + "static/media/FENGYUN 3D.37fca3b2.czml";